import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary, Link, Typography, Grid, makeStyles } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useResource } from "@rest-hooks/core";
import { ProductInfoLinkResource, ProductResource } from "@ploy-lib/rest-resources";
export const ProductInfo = (props) => {
    const { productExternalCode, header } = props;
    const products = useResource(ProductResource.list(), {});
    const classes = useStyles();
    const productId = products.find(p => p.externalCode === productExternalCode)?.id;
    const productInfoLinks = useResource(ProductInfoLinkResource.list(), productId
        ? {
            productId
        }
        : null);
    return (productInfoLinks?.length ?? 0) > 0 ? (_jsx(Grid, { item: true, xs: 12, className: classes.productInfoContainer, children: _jsxs(Accordion, { children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, {}), children: _jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { align: "center", children: header }) }) }), _jsx(AccordionDetails, { children: _jsx("div", { children: productInfoLinks?.map((productInfoLink) => (_jsx(Typography, { className: classes.typoClass, children: _jsx(Link, { href: productInfoLink.linkUrl, target: "_blank", rel: "noopener noreferrer", underline: "hover", children: productInfoLink.linkText }) }, productInfoLink.linkId))) }) })] }) })) : null;
};
const useStyles = makeStyles({
    productInfoContainer: {
        position: "relative",
        height: "50px",
        zIndex: 20
    },
    typoClass: {
        overflowWrap: "anywhere"
    }
});
//# sourceMappingURL=ProductInfo.js.map